/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProjectEntitlements } from './ProjectEntitlements';
import {
    ProjectEntitlementsFromJSON,
    ProjectEntitlementsFromJSONTyped,
    ProjectEntitlementsToJSON,
} from './ProjectEntitlements';

/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * The unique identifier for the project.
     * @type {string}
     * @memberof Project
     */
    id: string;
    /**
     * The unique name for the project.
     * @type {string}
     * @memberof Project
     */
    name: string;
    /**
     * The display name of the application, shown to end users during the connection flow.
     * @type {string}
     * @memberof Project
     */
    appName: string;
    /**
     * The ID of the organization that this project belongs to.
     * @type {string}
     * @memberof Project
     */
    orgId: string;
    /**
     * The time the project was created.
     * @type {Date}
     * @memberof Project
     */
    createTime: Date;
    /**
     * The time the project was updated.
     * @type {Date}
     * @memberof Project
     */
    updateTime?: Date;
    /**
     * 
     * @type {ProjectEntitlements}
     * @memberof Project
     */
    entitlements?: ProjectEntitlements;
}

/**
 * Check if a given object implements the Project interface.
 */
export function instanceOfProject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "appName" in value;
    isInstance = isInstance && "orgId" in value;
    isInstance = isInstance && "createTime" in value;

    return isInstance;
}

export function ProjectFromJSON(json: any): Project {
    return ProjectFromJSONTyped(json, false);
}

export function ProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Project {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'appName': json['appName'],
        'orgId': json['orgId'],
        'createTime': (new Date(json['createTime'])),
        'updateTime': !exists(json, 'updateTime') ? undefined : (new Date(json['updateTime'])),
        'entitlements': !exists(json, 'entitlements') ? undefined : ProjectEntitlementsFromJSON(json['entitlements']),
    };
}

export function ProjectToJSON(value?: Project | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'appName': value.appName,
        'orgId': value.orgId,
        'createTime': (value.createTime.toISOString()),
        'updateTime': value.updateTime === undefined ? undefined : (value.updateTime.toISOString()),
        'entitlements': ProjectEntitlementsToJSON(value.entitlements),
    };
}

